export default __webpack_public_path__ + "static/media/PROCESSMETHOD_PRINTING_SLA.b58ffa2a.png";